import { Component, OnInit, Input } from '@angular/core';
import { RootScopeService } from '../../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../../core/rootscope-declare';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-widget-step4',
  templateUrl: './widget-step4.component.html',
  styleUrls: ['./widget-step4.component.css']
})
export class WidgetStep4Component implements OnInit {

  rootScopeData: RootScopeDeclare;
  @Input() widgetUrl: string;
  textMessage: string;
  msgHideAndShow: boolean;


  constructor(private rootScopeService: RootScopeService, private _cookieService: CookieService, 
    private _amplitudeAnalytics: AmplitudeAnalyticsService, private _router: Router) 
  { this.getRootScopeData(); }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }
  ngOnInit(): void {
  }
  copyInputMessage(inputElement: { select: () => void; setSelectionRange: (arg0: number, arg1: number) => void; }, copyType: string) {
    inputElement.select();
    localStorage.setItem('CustomizedWidgetCopy', copyType);
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this._router.navigate(["/facility/equipment"]);
    
  }
}

